import { render, staticRenderFns } from "./WatchRecordedStreaming.vue?vue&type=template&id=94be470c&scoped=true&"
import script from "./WatchRecordedStreaming.vue?vue&type=script&lang=ts&"
export * from "./WatchRecordedStreaming.vue?vue&type=script&lang=ts&"
import style0 from "./WatchRecordedStreaming.vue?vue&type=style&index=0&id=94be470c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94be470c",
  null
  
)

export default component.exports